import { bool, shape, string } from 'prop-types'

export default {
  canonicalUrl: string,
  hasSubcategories: bool,
  id: string,
  isCategory: bool,
  isDirectChild: bool,
  name: string,
  redirectUrl: string,
  seoName: string,
  urlMappingForOtherShops: shape({}),
}
